import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";
import UserRoles from "constants/UserRoles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

const breadcrumbsStatic = [{
	name: 'Pay Center',
	url: '/pay_center',
	icon: 'users',
}];

class Pay_Center extends Framework.Components.View {

	constructor(props) {
		super(props, 'final_numbers');
	}

	refreshPage = () => {
		this.setState({
			key: Math.random(),
			refresh: !this.state.refresh
		});
	};

	render() {
		let {history, match} = this.props;

		return (
			<div className="container-fluid pay-center">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={history} />

				<Framework.Elements.UniversalModal
					regions={this.props.regions}
					name={`New Action Item For ${this.state.tab} Group`}
					object={Objects.ManagerTask}
					toggle={this.state.modalTaskAdd}
					reportClose={this.reportClose('modalTaskAdd')}
					afterSave={() => this.refreshPage()}
					hideGoTo={true}
					objectProps={{task_role: UserRoles[this.state.tab]}}
				/>

				<Tabs
					value={this.state.tab}
					onChange={this.handleTabChange}
					component={'div'}
					className="pay-center-tabs"
				>
					<Tab label="Commission" value="final_numbers"/>
					<Tab
						label={
							<span>
								<span className="full-width">Create Invoice</span>
								<span className="mobile">Invoice</span>
							</span>
						}
						value="invoice"
					/>
					<Tab label="History" value="approvals"/>
				</Tabs>

				<div className="pay-center-panel">
				{this.state.tab === 'final_numbers' &&
					<Collections.Individual_Final_Numbers
						key={this.state.key}
						history={history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						regions={this.props.regions}
						filter={UserRoles[this.state.tab]}
						allowDone={false}
						handleTabChange={this.handleTabChange}
						user={this.props.rootState.user}
					/>
				}

				{this.state.tab === 'invoice' &&
					<Objects.Invoice
						key={this.state.key}
						id={match.params.id}
						history={history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						regions={this.props.regions}
						handleTabChange={this.handleTabChange}
					/>
				}

				{this.state.tab === 'approvals' &&
					<Collections.Individual_Invoices
						key={this.state.key}
						history={history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						regions={this.props.regions}
						filter={UserRoles[this.state.tab]}
						allowDone={false}
						handleTabChange={(event, tab, func) => {
							this.handleTabChange(event, tab);
							if(typeof func === 'function') {
								func();
							}
						}}
						user={this.props.rootState.user}
					/>
				}
				</div>

			</div>
		);
	}
}

export default Framework.Components.withRootState(Pay_Center);

